<template>
  <div>
    <div class="billboard-pricelist-tnc" v-if="!isModalLoading">
      <div v-if="totalAircraft" class="billboard-pricelist-tnc__row">
        <div class="subhead">Total Aircraft</div>
        <h1>{{ totalAircraft + ' Aircraft' }}</h1>
      </div>
      <div v-if="itemQuantity" class="billboard-pricelist-tnc__row">
        <div class="subhead">Item Quantity</div>
        <h1>{{ pluralize(itemQuantity, capitalizeFirstLetter(itemQuantityUnit | formatNumber)) }}</h1>
      </div>
      <div v-if="averageTrafficPerMonth" class="billboard-pricelist-tnc__row">
        <div class="subhead">Average Traffic per Month</div>
        <h1>{{ averageTrafficPerMonth | formatNumber }} {{ ' Passenger' }}</h1>
      </div>
    </div>
    <a-loading v-else />
  </div>
</template>

<script>
import api from "@/api";
import { restEdge } from "@/api/edgeUrls";
import { globalMixins } from "@/lib/mixins/globalMixins";

import { ALoadingPrimary } from "ui-kit-v1";

export default {
  name: "adx-billboard-placement-tnc",
  components: {
    "a-loading": ALoadingPrimary
  },
  props: {
    placementId: {
      type: Number,
      required: false
    }
  },
  data() {
    return {
      isModalLoading: false,
      totalAircraft: null,
      itemQuantity: null,
      itemQuantityUnit: null,
      averageTrafficPerMonth: null
    };
  },
  computed: {},
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.loadData();
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    async loadData() {
      this.isModalLoading = true;
      const { data, status } = await api.get(
        restEdge.airlinesPlacement(this.placementId),
        { needToken: true, useRestEdge: true }
      );

      if (status === 200) {
        this.totalAircraft = data.airlines.aircraft;
        this.itemQuantity = data.product_qty;
        this.itemQuantityUnit = data.product_unit;
        this.averageTrafficPerMonth = data.airlines.traffic;
      }

      this.isModalLoading = false;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    pluralize(value, label) {
      if (value > 1) {
        return `${value} ${label}s`;
      }

      return `${value} ${label}`;
    }
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>